import React from 'react'
import { FolderTwoTone, CalendarTwoTone } from '@ant-design/icons';


const Metric = ({ title, value }) => {
    return (
        <div className="bg-gray-50 rounded-lg p-2 flex flex-col gap-[8px]">
            <div className="flex items-center gap-2">
                <CalendarTwoTone className="text-gray-600" />
                <span className="text-[10px] md:text-[12px] font-medium text-gray-600">{title}</span>
            </div>
            <div className="flex items-center justify-end">
                <p className="text-[12px] md:text-[16px] font-bold text-gray-800">{value}</p>
            </div>
        </div>
    );
};

const WorkEstimateCard = ({ slice }) => {
    if (!slice || !slice.points || slice.points.length < 2) {
        return null;
    }

    const [work, estimate] = slice.points;
    const { data: dataWork } = work;
    const { data: dataEstimate } = estimate;

    const horasTrabajadasNum = parseFloat(dataWork.y) || 0;
    const horasEstimadasNum = parseFloat(dataEstimate.y) || 0;
    const diferencia = horasTrabajadasNum - horasEstimadasNum;
    const porcentajeCompletado = horasEstimadasNum > 0 ? Math.round((horasTrabajadasNum / horasEstimadasNum) * 100) : 0;

    const getStatusColor = () => {
        if (diferencia > 0) return 'text-red-600 bg-red-50';
        if (diferencia < 0) return 'text-green-600 bg-green-50';
        return 'text-blue-600 bg-blue-50';
    };

    const getStatusText = () => {
        if (diferencia > 0) return `+${diferencia.toFixed(1)}  ${diferencia > 1 ? "Semanas" : "Semana"} sobre`;
        if (diferencia < 0) return `${Math.abs(diferencia).toFixed(1)}  ${Math.abs(diferencia) > 1 ? "Semanas" : "Semana"} debajo`;
        return 'Exacto';
    };

    return (
        <div className='w-[250px] md:w-[350px] bg-white shadow-lg border border-gray-200 p-2 rounded-sm flex flex-col gap-[12px] md:gap-[16px]'>
            <div className="flex items-center gap-4">
                <FolderTwoTone className="text-blue-600" />
                <h3 className="font-semibold text-gray-800 text-[12px] md:text-[16px]">{dataWork.x}</h3>
            </div>
            <div className="grid grid-cols-2 gap-4 mb-4">
                <Metric title="Trabajadas" value={horasTrabajadasNum} />
                <Metric title="Estimadas" value={horasEstimadasNum} />
            </div>

            <div className="">
                <div className="flex justify-between items-center mb-2">
                    <span className="text-[12px] font-medium text-gray-600">Presición</span>
                    <span className="text-[12px] font-bold text-gray-800">{porcentajeCompletado}%</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2">
                    <div
                        className={`h-2 rounded-full transition-all duration-300 ${porcentajeCompletado > 100 ? 'bg-red-500' :
                            porcentajeCompletado === 100 ? 'bg-green-500' : 'bg-blue-500'
                            }`}
                        style={{ width: `${Math.min(porcentajeCompletado, 100)}%` }}
                    ></div>
                </div>
            </div>

            <div className={`px-3 py-2 rounded-lg text-[12px] font-medium text-center ${getStatusColor()}`}>
                {getStatusText()}
            </div>
        </div>
    );
};


export default WorkEstimateCard